import { TipoParametroChoiceEnum } from '@/shared';

export const TEXTFIELD_TYPES = [
  TipoParametroChoiceEnum.TEXTO,
  TipoParametroChoiceEnum.NUMERICO,
  TipoParametroChoiceEnum.MODELO,
];

export const TEXTAREA_TYPES = [
  TipoParametroChoiceEnum.JSON,
  TipoParametroChoiceEnum.ARRAY,
];
